import { Injectable } from "@angular/core";
import { ComponentType } from "../../formulation-search/components/other-products/models/component-type";

@Injectable({ providedIn: 'root' })
export class AncillaryProductFilter {
    componentType: ComponentType;
}
